module.exports = __webpack_public_path__ + "components/carousel-nearby-mountains/static/generic-bg--8-973321d8622b3cda3403a2530bcd04be.jpg";